<template>
    <div class="mx-auto w-full max-w-[1168px] pb-40 px-8 pt-6">
        <ui-header :title="'View Submitted Progress Report'" :subtitle="progress.id">
        </ui-header>
        <div class="grid gap-6 grid-cols-12 pt-4 pb-6">
            <ui-date-picker label="Progress Report Date" name="date" v-model="progress.dateTime" class="xl:col-span-6"
                            placeholder="-"
                            :disabled="true"
                            :with-time="true"
            ></ui-date-picker>
            <ui-input label="Weather" name="weather" v-model="progress.weather"
                      :disabled="true"
                      placeholder="-"
                      class="xl:col-span-6"></ui-input>
            <ui-input label="Work as Specification" name="work_as_spec" v-model="progress.workAsSpecification"
                      :disabled="true"
                      placeholder="-"
                      class="xl:col-span-6"></ui-input>
            <ui-input label="Quality of Workmanship" name="quality_of_work" v-model="progress.qualityOfWorkmanship"
                      :disabled="true"
                      placeholder="-"
                      class="xl:col-span-6"></ui-input>
            <ui-textarea autoresize label="House Keeping" name="housekeeping" v-model="progress.houseKeeping"
                         :disabled="true"
                         placeholder="-"
                         class="xl:col-span-12"></ui-textarea>
            <ui-textarea autoresize label="Site Safety" name="site_safety" v-model="progress.siteSafety"
                         :disabled="true"
                         placeholder="-"
                         class="xl:col-span-12"></ui-textarea>
            <ui-textarea autoresize label="Comments" name="comments" v-model="progress.comments"
                         placeholder="-"
                         :disabled="true"
                         class="xl:col-span-12"></ui-textarea>
        </div>
        <div :key="contractRender">
            <div class="w-full mb-2 flex">
                <div class="flex-grow">Progress Percentages</div>
                <div class="flex-shrink mb-1">
                    <ui-button-new small
                                   class="items-baseline"
                                   icon="fas fa-upload"
                                   @click="showFS">Progress Report Files
                    </ui-button-new>
                </div>
            </div>
            <div class="w-full border-gray-300 border rounded-lg p-2">
                <progress-report-section v-for="section in progress.sections"
                                         :key="section.id"
                                         :progress="progress"
                                         :section="section"
                                         :fs-modal="fsModal"
                                         :readonly="true"
                ></progress-report-section>
            </div>
        </div>
    </div>
</template>

<script>
import UiContainer from "../ui/UiContainer.vue";
import UiDatePicker from "../ui/UiDatePicker.vue";
import UiButtonNew from "../ui/UiButtonNew.vue";
import UiDataGridItem from "../ui/UiDataGridItem.vue";
import UiHeader from "../ui/UiHeader.vue";
import UiInput from "../ui/UiInput.vue";
import UiToggle from "../ui/UiToggle.vue";
import {ProgressReport, ContractedWorks} from "@models";
import ProgressReportSection from "./ProgressReportSection.vue";
import {resolveNumericText, uuid} from "../../utils";
import Fs from "../filesystem/Fs.vue";
import ProgressReportTask from "./ProgressReportTask.vue";

export default {
    components: {
        ProgressReportTask,
        Fs,
        ProgressReportSection,
        UiToggle, UiInput, UiHeader, UiDataGridItem, UiDatePicker, UiButtonNew, UiContainer
    },
    props: {
        item: Object,
        progressId: '',
        packageReference: null,
        packageName: null,
        fsModal: Object,
    },
    data() {
        return {
            progress: {},
            contractRender: 0,
            busy: false
        }
    },
    computed: {},
    methods: {
        showFS() {
            this.fsModal.openModal(this.progress.filesystemId, this.progress.filesystemPath);
        }
    },
    async mounted() {
        this.progress = await ProgressReport.find(this.progressId);
        this.state = 'loaded'
        this.contractRender++;
    },
    beforeUpdate() {
    }
}
</script>
